import { useState, useEffect } from 'react'
import { sendLoginPayload } from 'account-portal-library/lib/emailSignIn';
import { validateSessionToken } from "account-portal-library/lib/helperFunctions";
import { getGotoUrlFromCookies } from '../../gotoUrl.js';
import { DigitInput } from '../Views/TO/Login/DigitInput';

import AppVars from './../../AppVars';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import LoadingGif from '../../static/images/loading.gif';
import Logo from '../../static/images/Toyota-Logo.svg';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const appVars = AppVars.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked";
const UNKNOWN_ERROR_URL = "/unknownerror";

const MfaEmailPage = ({ style = 'TO', savePayload, payload, saveStep, username }) => {
    const [smsData, setSmsData] = useState("");
    const [validNext, setValidNext] = useState(false);
    const [loading, setLoading] = useState(false);
    const [codeErr, setCodeErr] = useState(false);
    const [codeExp, setCodeExp] = useState(false);
    const [resendConfirmed, setResendConfirmed] = useState(false);

    useEffect(() => {
        if (resendConfirmed) {
            const timer = setTimeout(() => {
                setResendConfirmed(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [resendConfirmed]);

    useEffect(() => {
        if (codeExp) {
            const timer = setTimeout(() => {
                window.location.href = "/";
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [codeExp]);

    const onChange = (value) => {
        if (value.trim().length === 6) {
            setValidNext(true)
        } else {
            setValidNext(false)
        }
        setSmsData(value.trim())
    };

    const requestCodeApi = async (action) => {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            const headers = {
                'Accept-API-Version': 'resource=2.1',
                'Content-Type': 'application/json'
            }
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getMFATree()
            }
            const textPayload = payload;
            if (textPayload?.callbacks) {
                textPayload.callbacks[1].input[0].value = action === 1 ? "" : smsData;
                textPayload.callbacks[2].input[0].value = action;
            }
            const choiceResponse = await sendLoginPayload(textPayload, url, headers, params);
            setLoading(false);
            if (choiceResponse.status !== 200) {
                throw choiceResponse.response;
            }
            if (choiceResponse.response?.callbacks?.length === 3) {
                savePayload(choiceResponse.response);
                if (action === 1) {
                    setResendConfirmed(true);
                } else {
                    setCodeErr(true);
                }
            } else {
                handleSuccess(choiceResponse.response);
            }
        } catch (errorResponse) {
            console.log("Error -> ", errorResponse);
            handleFailure(errorResponse);
        }
    }

    //Checks that there is a session cookie on the browser
    const checkToken = async (journeyResponse) => {
        try {
            const tokenId = journeyResponse.tokenId;
            if (tokenId != null) {
                console.log("Token ID -> ", tokenId);
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                console.log("validateResponse -> ", validateResponse);
                return validateResponse.response.valid;
            } else {
                return false;
            }
        }
        catch {
            return false;
        }
    }

    const handleSuccess = async (journeyResponse) => {
        if (journeyResponse.callbacks == null) {
            const tokenValid = await checkToken(journeyResponse);
            console.log("Token Valid -> ", tokenValid);
            if (tokenValid) {
                const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
                navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
            } else {
                // Token was invalid for a successful response
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        } else {
            setLoading(false)
            if (journeyResponse.callbacks[0].type == 'HiddenValueCallback') {
                setCodeErr(true);
                setResendConfirmed(false);
            } else if (journeyResponse.callbacks[0].type == 'ChoiceCallback') {
                savePayload(journeyResponse)
                saveStep("TRUST")
            } else if (journeyResponse.callbacks[0].type == 'TextOutputCallback') {
                setResendConfirmed(true);
            } else if (journeyResponse.callbacks[0].type == 'RedirectCallback') {
                const redirectValue = journeyResponse.callbacks[0].output[0].value;
                navigateWithAnalytics(redirectValue, "cookie-redirect", "auto");
            } else {
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        }
    }

    const handleFailure = (journeyResponse) => {
        const failureUrl = journeyResponse.failureUrl
        //If invalid credentials
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            setLoading(false)
            navigateWithAnalytics(ACCOUNT_LOCKED_URL, "error-redirect", "auto");
        }
        else {
            if (journeyResponse.message === 'Session has timed out') {
                setCodeExp(true);
            } else {
                console.log(journeyResponse.message);
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        }
    }

    const onSubmit = () => {
        if (smsData.length === 6) {
            setLoading(true)
            requestCodeApi(0)
        }
    }

    const onResend = () => {
        setLoading(true)
        requestCodeApi(1)
    }

    return <div className="login-wrapper" >
        <div className="relative login-box">
            <img src={Logo} className="login-logo__TO absolute" alt="Toyota"></img>
            <div className="title__TO left">Email verification</div>
            <div className="sign-in-mfa-grid">
                <div className="message__TO left">Please enter the code we sent to {username}. This code will expire after 5 minutes. </div>
            </div>
            <form className='text-form'>
                <fieldset>
                    <legend>Enter 6-Digit Code</legend>
                    <DigitInput value={smsData} valueLength={6} onChange={onChange} />
                </fieldset>
                {codeErr && <div
                    data-testid="logonUsernameError"
                    className={`digit-alert ${codeErr ? "block" : "none"}`}
                    role="alert"
                    aria-hidden={`${codeErr ? "false" : "true"}`}
                >
                    Incorrect code entry. Please try again or request a new code. After 5 failed attempts, your account will be locked for security reasons.
                </div>}
                {codeExp && <div
                    data-testid="logonUsernameError"
                    className={`digit-alert ${codeExp ? "block" : "none"}`}
                    role="alert"
                    aria-hidden={`${codeExp ? "false" : "true"}`}
                >
                    Verification code has expired. Please select the option again to verify your identity.
                </div>}
                {resendConfirmed && <div
                    data-testid="logonUsernameError"
                    className={`digit-resent ${resendConfirmed ? "block" : "none"}`}
                    role="alert"
                    aria-hidden={`${resendConfirmed ? "false" : "true"}`}
                >
                    New code has been sent successfully.
                </div>}
            </form >
            <div className='mfa-button-group'>
                <Button bsPrefix="login-button-outline__TO button-duration" type="submit" onClick={onResend}>Resend Code</Button>
                <Button bsPrefix={validNext ? "login-button__TO" : "login-button-disabled__TO"} type="submit" onClick={onSubmit}>Next Step</Button>
            </div>
        </div>
        <Image data-testid="loadingGIF" className={`working ${loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
    </div>
}

export default MfaEmailPage;